// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths

export const useAnalyticsSideEffect = (adControlAnalyticsMethods, surfaceAnalyticsMethods) => ({
  action,
  contexts
}) => {
  var _contexts$module, _contexts$client$sess, _contexts$client, _fields$apps, _fields$apps2, _fields$apps3, _fields$apps4;
  const fields = (_contexts$module = contexts.module) === null || _contexts$module === void 0 ? void 0 : _contexts$module.fields;
  const recommendationSession = {
    type: 'appRec',
    id: (_contexts$client$sess = (_contexts$client = contexts.client) === null || _contexts$client === void 0 ? void 0 : _contexts$client.sessionId) !== null && _contexts$client$sess !== void 0 ? _contexts$client$sess : ''
  };
  switch (action.type) {
    case 'USER_VIEW_DISCOVERY_SURFACE':
      surfaceAnalyticsMethods.fireViewedUIEvent(action.payload.action, {
        source: action.payload.source,
        recommendedProductIds: (fields === null || fields === void 0 ? void 0 : (_fields$apps = fields.apps) === null || _fields$apps === void 0 ? void 0 : _fields$apps.map(app => app.productId)) || [],
        recommendationSession
      });
      break;
    case 'CLICK_APP_RECOMMENDATION':
      surfaceAnalyticsMethods.fireInteractedUIEvent(action.payload.action, {
        source: action.payload.source,
        targetProductId: action.payload.productId,
        recommendedProductIds: fields === null || fields === void 0 ? void 0 : (_fields$apps2 = fields.apps) === null || _fields$apps2 === void 0 ? void 0 : _fields$apps2.map(app => app.productId),
        recommendationSession
      }, {
        skipBenefitsPageExperimentCohort: action.payload.skipBenefitsPageExperimentCohort,
        tblzSwitcherRoleBasedExperimentCohort: action.payload.tblzSwitcherRoleBasedExperimentCohort
      });
      break;
    case 'DISMISS_APP':
    case 'OPEN_APP_DROP_DOWN_MENU':
    case 'SHOW_REASONS':
    case 'CLOSE_APP_DISMISSED_FLAG':
    case 'CLICK_PRIVACY_POLICY_LINK':
    case 'DISMISS_RECOMMENDATION_REASONS_MODAL':
      adControlAnalyticsMethods.fireInteractedUIEvent(action.payload.action, {
        source: action.payload.source,
        targetProductId: action.payload.productId,
        recommendedProductIds: fields === null || fields === void 0 ? void 0 : (_fields$apps3 = fields.apps) === null || _fields$apps3 === void 0 ? void 0 : _fields$apps3.map(app => app.productId),
        recommendationSession
      }, {
        tblzSwitcherRoleBasedExperimentCohort: action.payload.tblzSwitcherRoleBasedExperimentCohort
      });
      break;
    case 'USER_VIEW_RECOMMENDED_REASONS_SCREEN':
      adControlAnalyticsMethods === null || adControlAnalyticsMethods === void 0 ? void 0 : adControlAnalyticsMethods.fireViewedScreenEvent(action.payload.name, {
        recommendedProductIds: (fields === null || fields === void 0 ? void 0 : (_fields$apps4 = fields.apps) === null || _fields$apps4 === void 0 ? void 0 : _fields$apps4.map(app => app.productId)) || [],
        recommendationSession: recommendationSession,
        targetProductId: action.payload.productId
      });
      break;
    default:
      break;
  }
};